import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["category", "subcategory"]

  // Define the hierarchy mapping
  categorySubcategories = {
    foundation: ["system", "capability"],
    context: ["session", "environment"],
    task: ["instruction", "workflow", "template"],
    character: ["persona", "style", "brand_voice"]
  }

  connect() {
    // Filter subcategories on initial load (only if category is already selected)
    if (this.categoryTarget.value) {
      this.updateSubcategories()
    }
  }

  updateSubcategories() {
    const selectedCategory = this.categoryTarget.value
    const validSubcategories = this.categorySubcategories[selectedCategory] || []
    
    // Get current subcategory value
    const currentSubcategory = this.subcategoryTarget.value
    
    // Get all options
    const options = Array.from(this.subcategoryTarget.options)
    
    // Update the prompt option text if category is selected
    const promptOption = options[0]
    if (promptOption && promptOption.value === "") {
      if (selectedCategory) {
        promptOption.text = "Select a subcategory..."
      } else {
        promptOption.text = "Select a category first..."
      }
    }
    
    // Show/hide options based on valid subcategories
    options.forEach(option => {
      const optionValue = option.value
      
      // Skip the prompt option
      if (optionValue === "") {
        return
      }
      
      if (validSubcategories.includes(optionValue)) {
        option.style.display = ""
        option.disabled = false
      } else {
        option.style.display = "none"
        option.disabled = true
      }
    })
    
    // If no category selected or current selection is not valid, reset to prompt
    if (!selectedCategory || !validSubcategories.includes(currentSubcategory)) {
      this.subcategoryTarget.value = ""
    }
  }
}
